import { Form, NavLink } from 'react-router-dom';

import { hasAuthToken, isAdmin } from '../util/auth.jsx';

import classes from './SiteNavigation.module.css';

function UserMenu(props) {
  return (
    <>
      <nav>
        <ul>
          {!hasAuthToken() ?
            <li>
              <NavLink
                to="/auth?mode=login"
                onClick={props.closeMenu}
                className={({ isActive }) =>
                  isActive ? classes.active : undefined
                }
              >
                Login
              </NavLink>
            </li>
          :
          <>
            <li>
              <NavLink
                to="/advertise"
                onClick={props.closeMenu}
                className={({ isActive }) =>
                  isActive ? classes.active : undefined
                }
                end
              >
                Advertise
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/advertiseServices"
                onClick={props.closeMenu}
                className={({ isActive }) =>
                  isActive ? classes.active : undefined
                }
                end
              >
                Advertise Services
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/files"
                onClick={props.closeMenu}
                className={({ isActive }) =>
                  isActive ? classes.active : undefined
                }
                end
              >
                Files
              </NavLink>
            </li>
            {isAdmin() &&
              <li>
                <NavLink
                  to="/create-account"
                  onClick={props.closeMenu}
                  className={({ isActive }) =>
                    isActive ? classes.active : undefined
                  }
                >
                  Create Vendor Account
                </NavLink>
              </li>
            }
            <li>
              <NavLink
                to="/change-password"
                onClick={props.closeMenu}
                className={({ isActive }) =>
                  isActive ? classes.active : undefined
                }
                end
              >
                Change Password
              </NavLink>
            </li>
            <li>
              <Form action="logout" onSubmit={props.closeMenu} method="post">
                <button className="text-button {classes.active}">Logout</button>
              </Form>
            </li>
          </>
          }
        </ul>
      </nav>
    </>
  );
}

export default UserMenu;
